<template>
    <div class="meteor-shower">
      <img src="https://summit-img.geekpark.net/mobile/%E5%9B%9E%E9%A1%BE%E8%BF%87%E5%BE%80%E5%8D%81%E5%B9%B4-mobile.svg" style="width: 88vw">
      <img src="https://summit-img.geekpark.net/mobile/%E7%9C%BA%E6%9C%9B%E4%B8%8B%E4%B8%80%E4%B8%AA%E5%8D%81%E5%B9%B4-mobile.svg" style="width: 88vw;margin-top: 18vw">
    </div>
</template>

<script>
export default {
  name: 'MeteorShower'
}
</script>

<style scoped lang="less">
.meteor-shower{
  background: url("https://summit-img.geekpark.net/%E6%B5%81%E6%98%9F%E9%9B%A8%E5%BA%95%E5%9B%BE.v2.gif") 0 0/cover;
}
</style>
